export const ERRORS_KEYS = {
    CONTENT_IS_ON_REVIEW: 'CONTENT_IS_ON_REVIEW'
}